import MultislopeScreenSMK1D from './MultislopeScreenSMK1D.png';
import MultislopeScreenSMK2D from './MultislopeScreenSMK2D.png';
import MultislopeScreenSMM1D from './MultislopeScreenSMM1D.png';
import MultislopeScreenSMM2D from './MultislopeScreenSMM2D.png';
import MultislopeScreenSMK1D2 from './MultislopeScreenSMK1D_2.png';
import MultislopeScreenSMK2D2 from './MultislopeScreenSMK2D_2.png';
import MultislopeScreenSMM1D2 from './MultislopeScreenSMM1D_2.png';
import MultislopeScreenSMM2D2 from './MultislopeScreenSMM2D_2.png';

export const getImageMultislopeScreen = (decks: number, model: string) => {
  if (model.charAt(0) === 'S' && model.charAt(model.length - 1) === 'K') {
    switch (decks) {
      case 1:
        return MultislopeScreenSMK1D;
      case 2:
        return MultislopeScreenSMK2D;
      default:
        return MultislopeScreenSMK1D;
    }
  } else {
    switch (decks) {
      case 1:
        return MultislopeScreenSMM1D;
      case 2:
        return MultislopeScreenSMM2D;
      default:
        return MultislopeScreenSMM1D;
    }
  }
};

export const getImageMultislopeScreen2 = (decks: number, model: string) => {
  if (model.charAt(0) === 'S' && model.charAt(model.length - 1) === 'K') {
    switch (decks) {
      case 1:
        return MultislopeScreenSMK1D2;
      case 2:
        return MultislopeScreenSMK2D2;
      default:
        return MultislopeScreenSMK1D2;
    }
  } else {
    switch (decks) {
      case 1:
        return MultislopeScreenSMM1D2;
      case 2:
        return MultislopeScreenSMM2D2;
      default:
        return MultislopeScreenSMM1D2;
    }
  }
};
